import React from 'react';
import { BodyLarge, BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { Content, Header, } from '@shared/dialogs/DayNotesEntryDialog';
import Dialog from '@shared/ui/molecules/Dialog';
import styled from "styled-components";
import { smallTablet } from '@shared/ui/atoms/MediaQueries';
import { useTranslation } from "react-i18next";
import { closeDialog } from '@shared/store/dialog.duck';
import { useDispatch } from "react-redux";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';

export function HolidayRollOverConfirmationDialog(props: Props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const close = () => {
    dispatch(closeDialog());
  }
  return (
    <DialogWrapper isOpen={true} onClose={close}>
      <Header>
        <BodyLarge weight={600}>{t('allowance.confirm-dialog.title')}</BodyLarge>
      </Header>
      <BodyRegular style={{marginBottom: 8}}>{t('allowance.confirm-dialog.description-1', {previousYear: props.payload.previousYear, currentYear: props.payload.currentYear})}</BodyRegular>
      <BodyRegular style={{marginBottom: 8}}>{t('allowance.confirm-dialog.description-2')}</BodyRegular>
      <BodyRegular style={{marginBottom: 8}}>{t('allowance.confirm-dialog.description-3')}</BodyRegular>
      <Content>
        <PrimaryButton style={{margin: '24px auto 0 auto'}}
                       text={`allowance.confirm-dialog.continue`}
                       click={props.payload.confirmed}
                       fullWidth={true} />
        <OutlineButton style={{margin: '24px auto 0 auto'}}
                       text={`allowance.confirm-dialog.cancel`}
                       click={close}
                       fullWidth={true} />
      </Content>
    </DialogWrapper>
  )
}

interface Props {
  payload: {
    previousYear: number;
    currentYear: number;
    confirmed: () => any;
  };
}

const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    width: 100vw;
    height: 100vh;
    padding: 20px 0 0 0;
    @media (${smallTablet}) {
      padding: 20px 24px 24px 24px;
      max-width: 100%;
      min-height: 400px;
      width: unset;
      height: unset;
    }
  }
  .dialog__contentContainer, .dialog__content {
    width: 100%;
    padding-top: 0;
    @media (${smallTablet}) {
      width: 400px;
      min-height: 410px;
    }
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
`
